import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { AdvanceService } from "src/app/shared/services/advance.service";
import { AuthService } from "src/app/auth/auth.service";
import { Router } from "@angular/router";
import { map, shareReplay } from "rxjs/operators";
import { Advance, AdvanceTypes } from "src/app/shared/models/advance.model";
import { AlertService } from "src/app/shared/services/alert.service";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
})
export class NavbarComponent implements OnInit, OnDestroy {
  @Output() onClickElement = new EventEmitter();
  advances$;
  authEmployee$;

  constructor(
    private authService: AuthService,
    private advanceService: AdvanceService,
    private router: Router
  ) {}

  ngOnInit() {
    this.advances$ = this.advanceService.fetchCurrentUserAdvances().pipe(
      shareReplay(1),
      map((advances: Advance[]) => ({
        static: advances.find((v) => v.type.name === AdvanceTypes.Static),
        additional: advances.filter(
          (v) => v.type.name === AdvanceTypes.Additional
        ),
      }))
    );
    this.authEmployee$ = this.authService.authEmployee$;
  }

  ngOnDestroy() {}

  logout() {
    this.authService.logout().subscribe();
  }

  forceNavigation(event: Event, url: string) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    // Method 1: Navigate to home first, then redirect externally
    this.router.navigate(["/"]).then(result => {
      console.log('Router navigation result:', result);
      if (result) {
        // Small delay to ensure Angular route is processed
        setTimeout(() => {
          window.location.href = url;
        }, 100);
      } else {
        // If router navigation fails, try direct approach
        this.directNavigation(url);
      }
    }).catch(error => {
      console.error('Router navigation failed:', error);
      this.directNavigation(url);
    });
    
    // Also trigger mobile menu close
    this.onMobileHiddenNavbarAfterClick();
  }

  // Alternative method: Open in same window using window.open
  openInNewWindow(event: Event, url: string) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    // Use window.open with _self to force same-window navigation
    (window as any).open(url, "_self");
    this.onMobileHiddenNavbarAfterClick();
  }

  // Direct navigation as fallback
  private directNavigation(url: string) {
    try {
      window.location.assign(url);
    } catch (e) {
      try {
        document.location.href = url;
      } catch (e2) {
        console.error('All navigation methods failed');
      }
    }
  }

  // Most aggressive method to bypass Angular router
  forceExternalNavigation(event: Event, url: string) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    // Method 1: Immediate window.location.replace
    try {
      window.location.replace(url);
      return;
    } catch (e) {
      console.log('Method 1 failed, trying method 2');
    }
    
    // Method 2: Create form and submit it
    const form = document.createElement('form');
    form.method = 'GET';
    form.action = url;
    form.style.display = 'none';
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
    
    this.onMobileHiddenNavbarAfterClick();
  }

  onMobileHiddenNavbarAfterClick() {
    this.onClickElement.emit();
  }

  @HostListener("document:click", ["$event"])
  clickout(event: MouseEvent) {
    const element = event.target as HTMLElement;
    // if (['A', 'LABEL'].includes(element.tagName)) {
    this.onMobileHiddenNavbarAfterClick();
    // }
  }
}
